<div bsModal #myappBaseModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="auditLogDetailModal"
     aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog" [ngClass]="options?.modalCssClass">
        <div class="modal-content">
            <form *ngIf="active && !customOptions" #roleForm="ngForm">
                <div class="modal-header">
                    <h4 *ngIf="options && options?.title">
                        <div [innerHTML]="options?.title"></div>
                    </h4>
                    <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h4>
                        <div [innerHTML]="text"></div>
                    </h4>

                </div>
                <div class="modal-footer" *ngIf="!oneOptionMode">
                    <button type="button" class="btn btn-primary" (click)="onYes()">{{"Yes" | localize}}</button>
                    <button type="button" class="btn btn-default" (click)="onNo()">{{"No" | localize}}</button>
                </div>

                <div class="modal-footer" *ngIf="oneOptionMode">
                    <button type="button" class="btn btn-primary" (click)="onYes()">{{"Ok" | localize}}</button>
                </div>
            </form>
            <form *ngIf="active && customOptions" #roleForm="ngForm">
                <div class="modal-header">
                    <h4 *ngIf="options && options?.title">
                        <div [innerHTML]="options?.title"></div>
                    </h4>
                    <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h4 *ngIf="text">
                        <div [innerHTML]="text"></div>
                    </h4>
                    <div class="vertical-btn-container" *ngIf="options && options?.buttons && options?.verticalBtn">
                        <ng-container *ngFor="let button of buttons">
                            <ng-container *ngIf="button.isRedirectAction">
                                <button type="button"
                                        [attr.id]="button.idSelector"
                                        class="btn btn-primary"
                                        (click)="redirectTo(button.redirect)">{{button.title}}</button>
                            </ng-container>
                            <ng-container *ngIf="!button.isRedirectAction">
                                <button type="button"
                                        [attr.id]="button.idSelector"
                                        class="btn btn-primary"
                                        (click)="button.action(button.targetRole)">{{button.title}}</button>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="modal-footer" *ngIf="options && options?.buttons && !options?.verticalBtn">
                    <ng-container *ngFor="let button of buttons">
                        <ng-container *ngIf="button.isRedirectAction">
                            <button type="button"
                                    [attr.id]="button.idSelector"
                                    class="btn btn-primary"
                                    (click)="redirectTo(button.redirect)">{{button.title}}</button>
                        </ng-container>
                        <ng-container *ngIf="!button.isRedirectAction">
                            <button type="button"
                                    [attr.id]="button.idSelector"
                                    class="btn btn-primary"
                                    (click)="button.action(button.targetRole)">{{button.title}}</button>
                        </ng-container>
                    </ng-container>
                </div>
            </form>
        </div>
    </div>
</div>
